import { Link } from 'react-router-dom';
import { ArrowRight, Mail } from 'lucide-react';

export function CompareCta() {
  return (
    <section className="py-20 md:py-28 border-t border-zinc-100">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 text-center">
        <h2 className="font-display text-3xl md:text-4xl text-zinc-900 mb-3">
          See for yourself
        </h2>
        <p className="text-base text-zinc-500 mb-8 max-w-xl mx-auto">
          Start free, invite your team, paste your first ticket. No credit card, no per-seat pricing, no setup call required.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-6">
          <Link
            to="/auth"
            className="inline-flex items-center gap-2 rounded-full bg-zinc-900 text-white px-6 py-3 text-sm font-medium hover:opacity-90 transition-opacity"
          >
            Start for free <ArrowRight className="size-4" />
          </Link>
          <a
            href="mailto:founder@usekora.app"
            className="inline-flex items-center gap-2 rounded-full border border-zinc-200 text-zinc-700 px-6 py-3 text-sm font-medium hover:bg-zinc-50 transition-colors"
          >
            <Mail className="size-4" /> Talk to us
          </a>
        </div>
        <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-1 text-xs text-zinc-400">
          <span>No credit card</span>
          <span>·</span>
          <span>EU-hosted</span>
          <span>·</span>
          <span>Unlimited members</span>
          <span>·</span>
          <span>1,100 free credits</span>
        </div>
      </div>
    </section>
  );
}
